export { default as arbreFields } from './fields-OPOR23NG.json';
export { default as alignementFields } from './fields-Z72XEYMQ.json';
export { default as epaysageFields } from './fields-JAVEQRGM.json';
import essenceFieldsJson from './fields-LHTAR66P.json';
export { default as essenceFields } from './fields-LHTAR66P.json';

// src/index.ts
var fieldsWoodarea = essenceFieldsJson;

// src/arbre/print-configs.ts
var ARBRE_FIELDS_PRINT_CONFIG = [
  {
    name: "au-pied-de-l-arbre",
    label: "Au pied de l'arbre",
    type: "multiselect",
    required: true,
    options: [
      { id: "terre-litiere", label: "Terre, liti\xE8re" },
      { id: "vegetalisation", label: "V\xE9g\xE9talisation" },
      { id: "protection", label: "Protection" },
      { id: "enrobe", label: "Enrob\xE9" },
      { id: "materiau-drainant", label: "Mat\xE9riau drainant" }
    ]
  },
  {
    name: "caracteristiques-du-sujet-tronc",
    label: "Tronc",
    type: "radio",
    required: true,
    options: [
      { id: "tronc-unique", label: "Tronc unique" },
      { id: "tronc-multiples", label: "Tronc multiples" }
    ]
  },
  {
    name: "port-de-larbre",
    label: "Port de l'arbre",
    type: "radio",
    required: true,
    options: [
      { id: "port-libre", label: "Port libre" },
      { id: "semi-libre", label: "Semi-libre" },
      { id: "tete-de-chat", label: "T\xEAte de chat" },
      { id: "en-trogne", label: "En trogne" },
      { id: "rideau-marquise", label: "Rideau marquise" },
      { id: "taille-travaill\xE9e", label: "Taille travaill\xE9e" }
    ]
  },
  {
    name: "stade-de-developpement",
    label: "Stade de d\xE9veloppement",
    type: "radio",
    required: true,
    options: [
      { id: "jeune", label: "Juv\xE9nile" },
      { id: "adulte", label: "Adulte" },
      { id: "veillissant", label: "Mature" },
      { id: "senescent", label: "Vieillissant" }
    ]
  },
  {
    name: "critere-remarquable",
    label: "Crit\xE8re remarquable",
    type: "multiselect",
    required: true,
    options: [
      { id: "aucun", label: "Aucun" },
      { id: "valeur-historique", label: "Valeur historique" },
      { id: "port-hors-norme", label: "Port hors-norme" },
      { id: "taille-hors-norme", label: "Taille hors-norme" },
      { id: "essence-rare", label: "Essence rare" }
    ]
  },
  {
    name: "etat-sanitaire-systme-racinaire-collet",
    label: "Syst\xE8me racinaire et collet",
    type: "multiselect",
    required: true,
    options: [
      { id: "aucun-dfaut-apparent", label: "Aucun d\xE9faut apparent" },
      { id: "blessure-ncrose", label: "Blessure, n\xE9crose" },
      { id: "rejets-rsurgences-racinaires", label: "Rejets, r\xE9surgences racinaires" },
      { id: "soulvement-dcollement", label: "Soul\xE8vement, d\xE9collement" }
    ]
  },
  {
    name: "etat-sanitaire-tronc",
    label: "Tronc",
    type: "multiselect",
    required: true,
    options: [
      { id: "aucun-dfaut-apparent", label: "Aucun d\xE9faut apparent" },
      { id: "rejets", label: "Rejets" },
      { id: "inclinaison", label: "Inclinaison" },
      { id: "blessure-necrose", label: "Blessure, n\xE9crose" },
      { id: "fissuration-ecorce-incluse", label: "Ecorce incluse" },
      { id: "renflement", label: "Renflement" },
      { id: "echaudure", label: "Echaudure" },
      { id: "coulure-de-resine-gomme", label: "Coulure de r\xE9sine, gomme" }
    ]
  },
  {
    name: "etat-sanitaire-houppier",
    label: "Houppier",
    type: "multiselect",
    required: true,
    options: [
      { id: "aucun-dfaut-apparent", label: "Aucun d\xE9faut apparent" },
      { id: "rejets", label: "Rejets" },
      { id: "blessure-necrose", label: "Blessure, n\xE9crose" },
      { id: "echaudure", label: "Echaudure" },
      { id: "branche-a-risque", label: "Branches \xE0 risque" },
      { id: "bois-mort", label: "Bois mort" },
      { id: "fissuration-ecorce-incluse", label: "Ecorce incluse" },
      { id: "descente-de-cime", label: "Descente de cime" }
    ]
  },
  {
    name: "etat-sanitaire-general",
    label: "\xC9tat physiologique",
    type: "multiselect",
    required: true,
    options: [
      { id: "vigoureux", label: "Vigoureux" },
      { id: "vigueur-moyenne", label: "Vigueur moyenne" },
      { id: "peu-vigoureux", label: "Peu vigoureux" },
      { id: "regressif", label: "R\xE9gressif" },
      { id: "mort", label: "Mort" },
      { id: "exam-comple", label: "Examen compl\xE9mentaire requis" }
    ]
  },
  {
    name: "risque-de-rupture",
    label: "Risque de rupture",
    type: "table",
    required: true,
    tableConfig: {
      "cols": [
        {
          "id": "faible",
          "label": "Faible"
        },
        {
          "id": "modere",
          "label": "Mod\xE9r\xE9"
        },
        {
          "id": "eleve",
          "label": "Elev\xE9"
        },
        {
          "id": "imminent",
          "label": "Imminent"
        }
      ],
      rows: ["Collet", "Tronc", "Houppier"]
    }
  },
  {
    name: "implantation",
    label: "Implantation",
    type: "radio",
    required: true,
    options: [
      { id: "isole", label: "Isol\xE9" },
      { id: "en-groupe", label: "En groupe" },
      { id: "en-alignement", label: "En alignement" }
    ]
  },
  {
    name: "domaine",
    label: "Domaine",
    type: "radio",
    required: true,
    options: [
      { id: "espace-public", label: "Espace public" },
      { id: "propriete-privee", label: "Propri\xE9t\xE9 priv\xE9e" }
    ]
  },
  {
    name: "nuisances-constatees",
    label: "Nuisances constat\xE9es",
    type: "multiselect",
    required: true,
    options: [
      { id: "neant", label: "N\xE9ant" },
      { id: "perte-de-luminosit", label: "Perte de luminosit\xE9" },
      { id: "fructification-ou-feuillage", label: "Fructification ou feuillage" },
      { id: "branches-retombantes-sur-les-voies", label: "Branches retombantes sur les voies" },
      { id: "branches-dans-les-amnagements", label: "Branches dans les am\xE9nagements" },
      { id: "branches-dans-les-rseaux-ariens", label: "Branches dans les r\xE9seaux a\xE9riens" },
      { id: "pousse-racinaire-sur-les-amnagements", label: "Pouss\xE9e racinaire sur les am\xE9nagements" },
      { id: "systme-racinaire-dans-les-rseaux", label: "Syst\xE8me racinaire dans les r\xE9seaux" },
      { id: "dgradation-de-faade-toiture", label: "D\xE9gradation de fa\xE7ade, toiture" }
    ]
  },
  {
    name: "proximite-directe",
    label: "Proximit\xE9 directe",
    type: "multiselect",
    required: true,
    options: [
      { id: "neant", label: "N\xE9ant" },
      { id: "btiment-immeuble", label: "B\xE2timent, immeuble" },
      { id: "maison-individuelle", label: "Maison individuelle" },
      { id: "muret-clture-sparation", label: "Muret, cl\xF4ture, s\xE9paration" },
      { id: "chemin-voie-prive", label: "Chemin, voie priv\xE9e" },
      { id: "voie-de-circulation", label: "Voie de circulation" },
      { id: "parking-garage-box", label: "Parking, garage, box" },
      { id: "ecole-btiment-public", label: "Ecole, b\xE2timent public" },
      { id: "eclairage-public", label: "Eclairage public" },
      { id: "rseau-lectrique-gain", label: "R\xE9seau \xE9lectrique gain\xE9" },
      { id: "rseau-lectrique-non-gain", label: "R\xE9seau \xE9lectrique non gain\xE9" },
      { id: "rseau-souterrain", label: "R\xE9seau souterrain" },
      { id: "zone-en-chantier", label: "Zone en chantier" }
    ]
  },
  {
    name: "dict",
    label: "DICT",
    type: "multiselect",
    required: false,
    options: [
      { id: "eclairage-public", label: "Eclairage public" },
      { id: "rseau-lectrique-gain", label: "R\xE9seau \xE9lectrique gain\xE9" },
      { id: "rseau-lectrique-non-gain", label: "R\xE9seau \xE9lectrique non gain\xE9" },
      { id: "rseau-souterrain", label: "R\xE9seau souterrain" }
    ]
  },
  {
    name: "taux-de-frquentation",
    label: "Taux de fr\xE9quentation",
    type: "radio",
    required: true,
    options: [
      { id: "moins-d-une-pers-par-semaine", label: "Moins d'1 pers / semaine" },
      { id: "moins-de-douze-personnes-par-jour", label: "Moins de 12 pers / jour" },
      { id: "moins-dune-personne-par-heure", label: "Moins d'1 pers / heure" },
      { id: "moins-de-dix-personnes-par-heure", label: "Moins de 10 pers / heure" },
      { id: "moins-de-trente-six-personnes-par-heure", label: "Moins de 36 pers / heure" },
      { id: "passage-constant", label: "Passage constant" }
    ]
  },
  {
    name: "type-de-passage",
    label: "Type de passage",
    type: "multiselect",
    required: true,
    options: [
      { id: "pietons", label: "Pi\xE9tons" },
      { id: "vehicules", label: "V\xE9hicules" },
      { id: "velo-rollers", label: "V\xE9lo, rollers, d\xE9placements doux" }
    ]
  },
  {
    name: "accessibilite",
    label: "Accessibilit\xE9",
    type: "radio",
    required: true,
    options: [
      { id: "accs-facile-voie-route-chemin", label: "Acc\xE8s facile (voie, route, chemin...)" },
      { id: "non-accessible", label: "Non accessible" }
    ]
  },
  {
    name: "preco-travaux-abattage",
    label: "Abattage",
    type: "radio",
    required: true,
    options: [
      {
        id: "aucun-abattage",
        label: "Aucun abattage"
      },
      { id: "abattage-simple", label: "Abattage simple" },
      { id: "abattage-en-vue-de-remplacement", label: "Abattage en vue de remplacement" },
      { id: "abattage-par-demontage", label: "Abattage par d\xE9montage" }
    ]
  },
  {
    name: "preco-travaux-collet",
    label: "Collet",
    type: "multiselect",
    required: true,
    options: [
      { "label": "Aucun travaux", "id": "aucun-travaux" },
      { "label": "Pr\xE9servation de niche \xE9cologique", "id": "preservation-de-niche-ecologique" },
      { "label": "Coupe des rejets", "id": "coupe-des-rejets" },
      { "label": "Dessouchage", "id": "dessouchage" },
      { "label": "Mulchage, entretien du pied", "id": "mulchage-entretien-du-pied" },
      { "label": "Protection du pied", "id": "protection-du-pied" }
    ]
  },
  {
    name: "preco-travaux-tronc",
    label: "Tronc",
    type: "multiselect",
    required: true,
    options: [
      { "label": "Aucun travaux", "id": "aucun-travaux" },
      { "label": "Relev\xE9 de couronne", "id": "releve-de-couronne" },
      { "label": "Coupe du lierre", "id": "coupe-du-lierre" },
      { "label": "Mise en s\xE9curit\xE9", "id": "mise-en-securite" },
      { "label": "Coupe des rejets", "id": "coupe-des-rejets" },
      { "label": "Taille du gui", "id": "taille-du-gui" },
      { "label": "Traitement des parasites et des nuisibles", "id": "traitement-des-parasites" },
      { "label": "Pr\xE9servation de niche \xE9cologique", "id": "Pr\xE9servation de niche \xE9cologique" }
    ]
  },
  {
    name: "preco-travaux-houppier",
    label: "Houppier",
    type: "multiselect",
    required: true,
    options: [
      { "label": "Aucun travaux", "id": "aucun-travaux" },
      { "label": "Taille de cohabitation", "id": "taille-de-cohabitation" },
      { "label": "Taille de relev\xE9 de couronne", "id": "taille-de-relev-de-couronne" },
      { "label": "Taille d'all\xE8gement", "id": "taille-dallgement" },
      { "label": "Taille d'entretien", "id": "taille-dentretien" },
      {
        "label": "Taille d'\xE9claircie",
        "id": "taille-dclaircie"
      },
      {
        "label": "Nettoyage sanitaire",
        "id": "nettoyage-sanitaire"
      },
      {
        "label": "Mise en s\xE9curit\xE9 des branches \xE0 risque",
        "id": "mise-en-scurit-des-branches-risque"
      },
      { "label": "Taille du gui", "id": "taille-du-gui" },
      { "label": "Taille de gabarit", "id": "coupe-du-lierre" },
      { "label": "Taille travaill\xE9e", "id": "taille-travaille" },
      { "label": "Taille d'accompagnement", "id": "taille-daccompagnement" },
      { "label": "Taille de restructuration", "id": "taille-de-restructuration" },
      { "label": "Taille de formation", "id": "taille-de-formation" },
      { "label": "Conduite en trogne", "id": "conduite-en-trogne-ttard" },
      { "label": "Conduite architectur\xE9e", "id": "conduite-architecturee" },
      { "label": "Pr\xE9servation de niche \xE9cologique", "id": "prservation-de-niche-cologique" },
      { "label": "Traitement des nuisibles, parasites", "id": "traitement-des-nuisibles" },
      { "label": "Haubanage", "id": "haubanage" }
    ]
  },
  {
    name: "preco-travaux-date-travaux",
    label: "Ech\xE9ance",
    type: "radio",
    options: [
      { id: "immediat", label: "D\xE8s que possible" },
      { id: "1an", label: "Moins d'1 an" },
      { id: "2ans", label: "Moins de 2 ans" },
      { id: "3ans", label: "Moins de 3 ans" },
      { id: "5ans", label: "5 ans et plus" }
    ]
  },
  {
    name: "preco-travaux-com",
    label: "Commentaires",
    type: "textarea",
    placeholder: "Ajoutez vos commentaires..."
  },
  {
    name: "valeur-intrinseque-indice-espece",
    label: "Indice esp\xE8ce",
    type: "number",
    placeholder: "Entrez l'indice esp\xE8ce"
  },
  {
    name: "valeur-intrinseque-indice-sanitaire",
    label: "Indice sanitaire",
    type: "select",
    options: [
      { id: "vigoureux-sain", label: "Vigoureux - Sain" },
      { id: "vigoureux-malade", label: "Vigoureux - Malade" },
      { id: "vigoureux-deprissant", label: "Vigoureux - D\xE9p\xE9rissant" },
      { id: "vigueur-moyenne-sain", label: "Vigueur moyenne - Sain" },
      { id: "vigueur-moyenne-malade", label: "Vigueur moyenne - Malade" },
      { id: "vigueur-moyenne-deprissant", label: "Vigueur moyenne - D\xE9p\xE9rissant" },
      { id: "peu-vigoureux-sain", label: "Peu vigoureux - Sain" },
      { id: "peu-vigoureux-malade", label: "Peu vigoureux - Malade" },
      { id: "peu-vigoureux-deprissant", label: "Peu vigoureux - D\xE9p\xE9rissant" },
      { id: "sans-vigueur-sain", label: "Sans vigueur - Sain" },
      { id: "sans-vigueur-malade", label: "Sans vigueur - Malade" },
      { id: "sans-vigueur-deprissant", label: "Sans vigueur - D\xE9p\xE9rissant" }
    ]
  },
  {
    name: "valeur-intrinseque-indice-esthetique",
    label: "Indice esth\xE9tique",
    type: "select",
    options: [
      { id: "remarquable-solitaire", label: "Remarquable - Solitaire" },
      { id: "remarquable-groupe2-5", label: "Remarquable - Groupe < 5" },
      { id: "remarquable-groupe5+", label: "Remarquable - Alignement ou groupe > 5" },
      { id: "beau-sujet-solitaire", label: "Beau sujet - Solitaire" },
      { id: "beau-sujet-groupe2-5", label: "Beau sujet - Groupe < 5" },
      { id: "beau-sujet-groupe5+", label: "Beau sujet - Alignement ou groupe > 5" },
      { id: "mal-forme-age-solitaire", label: "Mal form\xE9, \xE2g\xE9 - Solitaire" },
      { id: "mal-forme-age-groupe2-5", label: "Mal form\xE9, \xE2g\xE9 - Groupe < 5" },
      { id: "mal-forme-age-groupe5+", label: "Mal form\xE9, \xE2g\xE9 - Alignement ou groupe > 5" },
      { id: "sans-interet-solitaire", label: "Sans int\xE9r\xEAt - Solitaire" },
      { id: "sans-interet-groupe2-5", label: "Sans int\xE9r\xEAt - Groupe < 5" },
      { id: "sans-interet-groupe5+", label: "Sans int\xE9r\xEAt - Alignement ou groupe > 5" }
    ]
  },
  {
    name: "valeur-intrinseque-indice-situation",
    label: "Indice de situation",
    type: "radio",
    options: [
      { id: "10", label: "Centre ville" },
      { id: "8", label: "Agglom\xE9ration" },
      { id: "6", label: "Zone rurale" }
    ]
  }
];

// src/beva/constants.ts
var LOCATION_INDEX_TAB = [
  { displayName: "Centre ville", name: 10 },
  { displayName: "Agglom\xE9ration", name: 8 },
  { displayName: "Zone rurale", name: 6 }
];
var RISQUE_GENERAL_TAB = [
  {
    name: "faible",
    displayName: "Faible"
  },
  {
    name: "modere",
    displayName: "Mod\xE9r\xE9"
  },
  {
    name: "eleve",
    displayName: "Elev\xE9"
  },
  {
    name: "imminent",
    displayName: "Imminent"
  },
  {
    name: "other",
    displayName: "Commentaire :"
  }
];
var HEALTH_INDEX_TAB = [
  { displayName: "Sain - Vigoureux", name: 1 },
  { displayName: "Sain - Vigueur moyenne", name: 2 },
  { displayName: "Sain - Peu vigoureux", name: 3 },
  { displayName: "Sain - Sans vigueur", name: 4 },
  { displayName: "Malade - Vigoureux", name: 5 },
  { displayName: "Malade - Vigueur moyenne", name: 6 },
  { displayName: "Malade - Peu vigoureux", name: 7 },
  { displayName: "Malade - Sans Vigueur", name: 8 },
  { displayName: "D\xE9p\xE9rissant - Peu vigoureux", name: 11 },
  { displayName: "D\xE9p\xE9rissant - Sans vigueur", name: 12 }
];
var AESTHETIC_INDEX_TAB = [
  { displayName: "Solitaire - Remarquable", name: 1 },
  { displayName: "Solitaire - Beau sujet", name: 2 },
  { displayName: "Solitaire - Mal form\xE9, \xE2g\xE9", name: 3 },
  { displayName: "Solitaire - Sans int\xE9r\xEAt", name: 4 },
  { displayName: "Groupe < 5 - Remarquable", name: 5 },
  { displayName: "Groupe < 5 - Beau sujet", name: 6 },
  { displayName: "Groupe < 5 - Mal form\xE9, \xE2g\xE9", name: 7 },
  { displayName: "Groupe < 5 - Sans int\xE9r\xEAt", name: 8 },
  { displayName: "Alignement groupe > 5 - Beau sujet", name: 10 },
  { displayName: "Alignement groupe > 5 - Mal form\xE9, \xE2g\xE9", name: 11 },
  { displayName: "Alignement groupe > 5 - Sans int\xE9r\xEAt", name: 12 }
];
var AESTHETIC_INDEX_VALUE = [
  { column: 1, value: 6 },
  { column: 2, value: 5 },
  { column: 3, value: 3 },
  { column: 4, value: 1 },
  { column: 5, value: 5 },
  { column: 6, value: 4 },
  { column: 7, value: 2 },
  { column: 8, value: 1 },
  { column: 10, value: 4 },
  { column: 11, value: 2 },
  { column: 12, value: 1 }
];
var HEALTH_INDEX_VALUE = [
  { column: 1, value: 4 },
  { column: 2, value: 2 },
  { column: 3, value: 1 },
  { column: 4, value: 1 },
  { column: 5, value: 2 },
  { column: 6, value: 2 },
  { column: 7, value: 1 },
  { column: 8, value: 1 },
  { column: 11, value: 1 },
  { column: 12, value: 0 }
];

// src/beva/helper.ts
var BevaHelper = class _BevaHelper {
  constructor() {
  }
  /**
   *
   * @param column
   * @param data
   */
  static getValueColumn(column, data) {
    if (column === null || column === void 0) return null;
    const found = data?.find((elt) => elt?.column == column);
    return found?.value ?? null;
  }
  static getNameColumnIndex(displayName, data, dataIndex) {
    if (displayName === null || displayName === void 0) return void 0;
    const found = dataIndex.find(
      (elt) => elt.displayName == displayName
    );
    if (!found) return void 0;
    const result = _BevaHelper.getValueColumn(found.name, data);
    return result ?? void 0;
  }
  /**
   *
   * @param index
   * @param data
   */
  static getDisplayNameIndex(index, data) {
    if (!index) return null;
    const found = data.find((elt) => elt.name == index);
    return found?.displayName ?? null;
  }
  /**
   *
   * @param index
   * @param data
   */
  static getNameIndex(index, data) {
    if (!index) return void 0;
    const found = data.find((elt) => elt.displayName == index);
    return found?.name;
  }
};

// src/beva/size-index.ts
function getSizeIndexFromDiameter(diametre) {
  if (diametre === null || diametre === void 0) {
    return 0;
  }
  const circ = Math.round(diametre * Math.PI);
  if (circ >= 10 && circ <= 14) return 0.5;
  if (circ >= 15 && circ <= 22) return 0.8;
  if (circ >= 23 && circ <= 40) return 1;
  if (circ >= 41 && circ <= 60) return 2;
  if (circ >= 61 && circ <= 70) return 3;
  if (circ >= 71 && circ <= 80) return 5;
  if (circ >= 81 && circ <= 90) return 6;
  if (circ >= 91 && circ <= 100) return 8;
  if (circ >= 101 && circ <= 110) return 9.5;
  if (circ >= 111 && circ <= 120) return 11;
  if (circ >= 121 && circ <= 130) return 12.5;
  if (circ >= 131 && circ <= 140) return 14;
  if (circ >= 141 && circ <= 150) return 15;
  if (circ >= 151 && circ <= 160) return 16;
  if (circ >= 161 && circ <= 170) return 17;
  if (circ >= 171 && circ <= 180) return 18;
  if (circ >= 181 && circ <= 190) return 19;
  if (circ >= 191 && circ <= 200) return 20;
  if (circ >= 201 && circ <= 220) return 21;
  if (circ >= 221 && circ <= 240) return 22;
  if (circ >= 241 && circ <= 260) return 23;
  if (circ >= 261 && circ <= 280) return 24;
  if (circ >= 281 && circ <= 300) return 25;
  if (circ >= 301 && circ <= 320) return 26;
  if (circ >= 321 && circ <= 340) return 27;
  if (circ >= 341 && circ <= 360) return 28;
  if (circ >= 361 && circ <= 380) return 29;
  if (circ >= 381 && circ <= 400) return 30;
  if (circ >= 401 && circ <= 420) return 31;
  if (circ >= 421 && circ <= 440) return 32;
  if (circ >= 441 && circ <= 460) return 33;
  if (circ >= 461 && circ <= 480) return 34;
  if (circ >= 481 && circ <= 500) return 35;
  if (circ >= 501 && circ <= 600) return 40;
  if (circ >= 601) return 45;
  return 0;
}
function buildBevaDetail(input) {
  const varietyGrade = Number(input.varietyGrade ?? 0);
  const healthIndex = Number(input.healthIndex ?? 0);
  const aestheticIndex = Number(input.aestheticIndex ?? 0);
  const locationIndex = Number(input.locationIndex ?? 0);
  const sizeIndex = getSizeIndexFromDiameter(input.diametre ?? null);
  const aestheticHealthIndex = aestheticIndex + healthIndex;
  const hasIndices = varietyGrade > 0 && locationIndex > 0 && sizeIndex > 0 && aestheticHealthIndex > 0;
  if (!hasIndices) {
    return null;
  }
  let beva;
  if (input.bevaOverride !== null && input.bevaOverride !== void 0 && input.bevaOverride !== "" && input.bevaOverride !== "\u2014") {
    const parsed = typeof input.bevaOverride === "number" ? input.bevaOverride : parseFloat(String(input.bevaOverride).replace(/\s/g, "").replace(",", "."));
    beva = Number.isFinite(parsed) ? parsed : NaN;
  } else {
    beva = Math.round(
      aestheticHealthIndex * varietyGrade * locationIndex * sizeIndex * 100
    ) / 100;
  }
  if (!Number.isFinite(beva) || beva <= 0) {
    return null;
  }
  return {
    numero: input.inventaireId != null && String(input.inventaireId).trim() !== "" ? String(input.inventaireId) : "\u2014",
    genre: (input.genre ?? "").trim() || "\u2014",
    espece: (input.espece ?? "").trim() || "\u2014",
    nomVernaculaire: (input.nomVernaculaire ?? "").trim() || "\u2014",
    varietyGrade,
    aestheticHealthIndex,
    locationIndex,
    sizeIndex,
    beva
  };
}
function formatBevaNumber(value) {
  return new Intl.NumberFormat("fr-FR", {
    maximumFractionDigits: 2
  }).format(value);
}

// src/arbre/sanitize-etat-sanitaire.ts
var EXAM_COMPLE_ID = "exam-comple";
var EXAM_LABEL = "Examen compl\xE9mentaire requis";
function hasExamComplementaire(etatSanGeneral) {
  if (!etatSanGeneral) return false;
  const values = Array.isArray(etatSanGeneral) ? etatSanGeneral : [etatSanGeneral];
  return values.some((item) => {
    const normalized = String(item).toLowerCase();
    return normalized.includes(EXAM_COMPLE_ID) || normalized.includes("examen compl\xE9mentaire");
  });
}
function sanitizeEtatSanitaireGeneral(label, options) {
  if (!label) return " ";
  let result = String(label);
  const hasExam = options?.hasExamComplementaire === true;
  result = result.replace(
    /Examen\s+complémentaire\s+requis\s*:\s*(Oui|Non)/gi,
    hasExam ? EXAM_LABEL : ""
  );
  if (!hasExam) {
    result = result.replace(/Examen\s+complémentaire\s+requis/gi, "");
  }
  if (options?.otherText) {
    result = result.replace(/\bother\b/gi, options.otherText);
  }
  result = result.replace(/,\s*,/g, ",").replace(/^\s*,\s*/g, "").replace(/\s*,\s*$/g, "").replace(/\s{2,}/g, " ").trim();
  return result || " ";
}

export { AESTHETIC_INDEX_TAB, AESTHETIC_INDEX_VALUE, ARBRE_FIELDS_PRINT_CONFIG, BevaHelper, HEALTH_INDEX_TAB, HEALTH_INDEX_VALUE, LOCATION_INDEX_TAB, RISQUE_GENERAL_TAB, buildBevaDetail, fieldsWoodarea, formatBevaNumber, getSizeIndexFromDiameter, hasExamComplementaire, sanitizeEtatSanitaireGeneral };
